var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"pinballCanvas",attrs:{"width":"800","height":"600"}}),(_vm.gameOver)?_c('div',{staticClass:"game-over"},[_c('p',[_vm._v("You lose! Score: "+_vm._s(_vm.score))]),_c('button',{on:{"click":_vm.restartGame}},[_vm._v("Play Again")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }